import { DatePipe } from '@angular/common';
import { Component, OnInit, Input, SimpleChanges, ViewChild, ElementRef, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { GlobalService } from '../../services/global.service';
import { FilterService } from '../../services/filter.service';


@Component({
    selector: 'app-line-graph',
    templateUrl: './line-graph.component.html',
    styleUrls: ['./line-graph.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LineGraphComponent implements OnInit {

	@ViewChild('barsgraph') divToMeasureElement: ElementRef;
	@ViewChild('legendgraph') legendgraph: ElementRef;
	@ViewChild('contextlegend') contextlegend: ElementRef;
	@ViewChild('tablegraph') tablegraph: ElementRef;
	@ViewChild('contextWrapper') contextWrapper: ElementRef;

	@Input() showNumber: number;
	@Input() showNumberGraph: number = 5;
	@Input() autoShowNumber: boolean = true; // calculates showNumberGraph automatically
	@Input() accumulative: boolean = false;
	@Input() xlabel: string;
	@Input() ylabel: string;
	/** Data type shown on Y axis */
	@Input('dataType') dataTypeY: string;
	/** Data type shown on X axis */
	@Input() dataTypeX: string;
	/** Value type shown on hover */
	@Input() valueType: string;
	@Input() showLegend: boolean = false;
	@Input() theme: string = 'default';


	@Input() height: number = 400;
	@Input() list: any;
	@Input() xlabelValue: string
	@Input() lineObjects: any;
	@Input() overlap: boolean;
	@Input() id: string = 'id';
	@Input() hoverElements: boolean = false;
	@Input() spaceLegends: number = 15; //percentage space to the right of legends (if shown)
	@Input() textToSearch?: string;
	@Input() searchOptions?: Array<any>;
	@Input() widthXLabel: number = 35; // width of X label
	@Input() showAlwaysDots: boolean = true;
	@Input() showAverage: boolean = false;
	@Input() averageValue: string = 'average';
	@Input() defaultMax: number;
	@Input() showColorsDefault: boolean = true;

	readonly BOX_SIZE: number = 35;
	readonly GAP_Y: number = 10;
	readonly MIN_MAX: number = 10;

	max: number;
	rangeNumber: number = 10;
	viewBoxwidth: number = 1024;
	viewBoxheigth: number = 500;
	separatorIndex: number = 50;
	viewBoxSize: string = "0 0 1024 500";
	position: number = 0;
	positionGraph: number = 0;
	range: any = [];
	startY: number = 0;
	gap: number = 11;
	filteredLineObjects: any;
	showSummary: boolean = false;
	contextmenu = {
		'x': '',
		'y': ''
	};
	selectedXItem: any = {};
	isSmall: boolean = false;
	intervalLabel = {
		'y': 1,
		'x': 1
	}
	radiusCircle: number = 4;

	next(isObjects = false) {
		if (isObjects) {
			this.positionGraph += this.showNumberGraph;
			return;
		}
		this.position += 1;
		this.toggleSummary(null, false);
	}

	previous(isObjects = false) {
		if (isObjects) {
			this.positionGraph -= this.showNumberGraph;
			if (this.positionGraph < 0) {
				this.positionGraph = 0;
			}
			return;
		}

		this.position -= 1;
		if (this.position < 0) {
			this.position = 0;
		}
		this.toggleSummary(null, false);
	}

	getSpaceX() {
		return (this.viewBoxwidth - this.BOX_SIZE - this.gap) / (this.showNumber + 1)
	}

	labelPosition(pos) {
		var a = this.BOX_SIZE + (this.getSpaceX() * (pos + 1));
		return a
	}

	getBarWidth() {
		var a = this.getSpaceX();
		if (this.overlap) {
			return a * 0.5
		} else {
			return a / (this.lineObjects.length + 1) * .8
		}

	}

	getBarX(pos, gPos) {
		var a = this.getSpaceX();
		if (this.overlap) {
			return this.labelPosition(pos) - this.getBarWidth() / 2
		} else {
			return (this.labelPosition(pos) + (this.getBarWidth() * (gPos)) + (a / (this.lineObjects.length + 1) * .2 * (gPos + 1))) - (a / 2) - (a / (this.lineObjects.length + 1) * .1) + (a / (this.lineObjects.length + 1) * 0.5)
		}

	}

	getXLabel(item, isContext = false) {
		if (this.xlabelValue) {
			return this.dataTypeX == 'date' ?
				this._dP.transform(item[this.xlabelValue], isContext ? 'MMM-dd-yyyy' : 'MMM-dd') :
				item[this.xlabelValue]
		}
		return "--";
	}

	getMinutes(ev) {
		var min = Math.floor(ev / 60)
		var sec = ev - (min * 60)

		if (sec < 10) {
			return min + ':0' + sec
		} else {
			return min + ':' + sec
		}
	}

	setViewBoxSizes() {
		setTimeout(() => {
			this.viewBoxwidth = this.divToMeasureElement.nativeElement.offsetWidth;
			this.isSmall = this.viewBoxwidth < 400;
			this.viewBoxwidth = this.showLegend && !this.isSmall ? this.viewBoxwidth - ((this.viewBoxwidth * this.spaceLegends) / 100) : this.viewBoxwidth;
			this.viewBoxheigth = this.height > 100 ? this.height : 100;
			this.radiusCircle = this.height > 200 ? 4 : 3;
			this.startY = this.viewBoxheigth - 20;
			this.viewBoxSize = "0 0 " + this.viewBoxwidth + " " + this.viewBoxheigth;
			this.separatorIndex = (this.viewBoxheigth - 30) / this.rangeNumber;
			this.range = new Array(this.rangeNumber);
			this.calculateYLabelRange();
			this.calculateXLabelRange();
			this.calculateShowNumberGraph();
			this._cD.detectChanges();
		}, 0)
	}

	calculateShowNumberGraph() {
		if (!this.autoShowNumber || !this.legendgraph) return;
		const Y_TEXT_HEIGHT = 17; // height of text.
		const MIN_GAP = 80; // space for buttons
		let graphBoxHeight = (this.viewBoxheigth - 20) - this.GAP_Y;
		let isYCalculated = false;
		this.showNumberGraph = 1;
		while (!isYCalculated) {
			if (graphBoxHeight - (Y_TEXT_HEIGHT * this.showNumberGraph) > MIN_GAP) {
				this.showNumberGraph++;
			} else {
				isYCalculated = true;
			}
		}

		if (this.showNumberGraph < 5) this.showNumberGraph = 5;
		if (this.showNumberGraph > 10) this.showNumberGraph = 10;
	}

	calculateXLabelRange() {
		let graphBoxWidth = this.getXValue(this.showNumber + 1) - this.BOX_SIZE;
		let isXCalculated = false;
		let relativeNumberItems = this.showNumber;
		this.intervalLabel.x = 1;
		while (!isXCalculated) {
			let numberItems = Math.round(relativeNumberItems / this.intervalLabel.x);
			let minGap = this.dataTypeX == 'date' ? 100 : 70;
			if (graphBoxWidth - (this.widthXLabel * numberItems) > minGap || numberItems == 1) {
				isXCalculated = true;
			} else {
				this.intervalLabel.x++;
			}
		}
	}

	calculateYLabelRange() {
		const Y_TEXT_HEIGHT = 13; // height of text.
		let graphBoxHeight = (this.viewBoxheigth - 20) - this.GAP_Y;
		let isYCalculated = false;
		let relativeNumberItems = this.rangeNumber;
		this.intervalLabel.y = 1;
		while (!isYCalculated) {
			let numberItems = Math.round(relativeNumberItems / this.intervalLabel.y);
			if (graphBoxHeight - (Y_TEXT_HEIGHT * numberItems) > 32 || numberItems == 1) { // 30 min total space gap.
				isYCalculated = true;
			} else {
				this.intervalLabel.y++;
			}
		}
	}

	getPointsArrow(type: string) {
		const CY = this.viewBoxheigth / 2;
		const NUMBER_ONE = 6;
		const NUMBER_TWO = 2;
		if (type == 'left') {
			const CX = 55;
			return `${CX - NUMBER_ONE},${CY} ${CX + NUMBER_TWO},${CY - NUMBER_ONE}, ${CX + NUMBER_TWO},${CY + NUMBER_ONE}`;
		} else if (type == 'right') {
			const CX = this.viewBoxwidth - this.BOX_SIZE;
			return `${CX + NUMBER_ONE},${CY} ${CX - NUMBER_TWO},${CY - NUMBER_ONE}, ${CX - NUMBER_TWO},${CY + NUMBER_ONE}`;
		}
	}

	setMax() {
		if (this.defaultMax) {
			this.max = this.defaultMax;
			return;
		}

		const PERCENT_ADDITIONAL = 0.02;
		if (this.accumulative) {
			let m = 0;
			for (let val of this.lineObjects) {
				if (val.total_accumulative > m || val[this.averageValue] > m) {
					let x = val[this.averageValue]
						? val[this.averageValue] > val.total_accumulative
							? (val[this.averageValue] * PERCENT_ADDITIONAL) + val[this.averageValue]
							: val.total_accumulative
						: val.total_accumulative

					m = Math.ceil(x);
				}
			}
			this.max = (Math.ceil(m / 10) * 10) || this.MIN_MAX;
			return;
		}

		if (this.dataTypeY != "percent") {
			var m = 0;
			for (let val of this.lineObjects) {
				for (const item of val[val.items]) {
					let a = item[val.valid_property];
					if (Math.ceil(a) > m) {
						m = Math.ceil(a);
					}
				}
			}
			this.max = (Math.ceil(m / 10) * 10) || this.MIN_MAX;
		}
	}

	getXValue(index) {
		return this.BOX_SIZE + (this.getSpaceX() * index);
	}

	getYValue(item, graph, type, isLast?) {
		let foundIndex = graph[graph.items].findIndex(i => i[this.id] == item.id);
		foundIndex = isLast ? foundIndex + 1 : foundIndex;
		if (type == 'start') {
			let foundItem = graph[graph.items][foundIndex - 1];
			return foundItem ? this.startY - (((this.viewBoxheigth - 30) * foundItem[graph.valid_property]) / this.max) : this.startY;
		} else if (type == 'end') {
			let foundItem = graph[graph.items][foundIndex];
			return foundItem ? this.startY - (((this.viewBoxheigth - 30) * foundItem[graph.valid_property]) / this.max) : this.startY;
		}
	}

	toggleActiveGraph(graph, value) {
		this.selectedXItem = {}
		this.showSummary = false;
		graph.isActive = value;
	}

	toggleSummary(event, value, reset?) {
		this.showSummary = value;
		if (!this.showSummary) {
			this.selectedXItem = reset ? {} : this.selectedXItem;
			event ? event.stopPropagation() : null;
			return;
		}

		let rect = event.currentTarget.getBoundingClientRect();
		let position = {
			'xRelative': Math.round(event.clientX - rect.left), //x position within the element.
			'yRelative': Math.round(event.clientY - rect.top), //y position within the element.
			'startPosition': 0,
			'endPosition': 0,
			'halfPosition': 0
		}

		let shownList = this.list.slice(this.position, this.showNumber + this.position); // Items shown.
		let shownGraphItems = this.filteredLineObjects.slice(this.positionGraph, this.showNumberGraph + this.positionGraph);
		let finishXAxis = this.getXValue(this.showNumber + 1);

		// Not hover inside graph, stops execution.
		if (position.yRelative < this.GAP_Y
			|| position.xRelative < this.BOX_SIZE
			|| position.yRelative >= this.viewBoxheigth - 20
			|| position.xRelative >= finishXAxis) {
			this.showSummary = false;
			this.selectedXItem = {};
			return;
		}
		let x = 0;
		for (let i = 0; i <= this.showNumber; i++) {
			position.startPosition = i == 0 ? this.BOX_SIZE : this.labelPosition(i - 1);
			position.endPosition = this.labelPosition(i);
			position.halfPosition = (position.startPosition + position.endPosition) / 2;

			// Evaluates if position of hover is between the start and end position defined.
			if ((position.xRelative >= position.startPosition && position.xRelative < position.endPosition) || shownList.length < (i + 1)) {
				x = this.setGraphSummary(position, shownList, shownGraphItems, i, rect);
				break;
			}
		}
		// this.defineBoundariesContext(event); use mouseleave. Has problem with arrows paginate.
		let y = event.clientY < (window.innerHeight) ? event.clientY : window.innerHeight;
		this.validateContext((x + 15), (y + 15));
	}

	defineBoundariesContext(event) {
		// if (!this.contextlegend) return;
		// let y = (event.clientY + 15) < (window.innerHeight - this.contextlegend.nativeElement.clientHeight)
		// 	? event.clientY + 15
		// 	: window.innerHeight - this.contextlegend.nativeElement.clientHeight;
		// this.contextmenu.y = y + 'px';
	}

	validateContext(x, y) {
		setTimeout(() => {
			let valid = this._gS.validateContextPositionManual(x, y);
			this.contextmenu.y = valid.y + 'px';
			this.contextmenu.x = valid.x + 'px';
			this._cD.detectChanges();
		})
	}

	setGraphSummary(position, shownList, shownGraphItems, i, rect): number {

		const GREATER_THAN_HALF = position.xRelative > position.halfPosition && shownList.length > i;
		let relativeIndexGraph = GREATER_THAN_HALF ? (i + 1) : i;
		let indexItem = shownList.length < relativeIndexGraph ? (shownList.length - 1) : relativeIndexGraph - 1;

		if (indexItem < 0) { // Not found index in showList. But may have element before.
			let foundIndex = this.list.findIndex(item => item[this.id] == shownList[0][this.id]);
			if ((foundIndex - 1) < 0) { // No data for this element. Stops execution
				this.showSummary = false;
				this.selectedXItem = {};
				return;
			}
			this.selectedXItem = this.list[foundIndex - 1]; // select item before since it exists
		} else {
			this.selectedXItem = shownList[indexItem];
		}

		let x = (rect.left + (GREATER_THAN_HALF ? position.endPosition : position.startPosition) + 8);

		for (const graph of shownGraphItems) {
			let foundIndex = graph[graph.items].findIndex(item => item[this.id] == this.selectedXItem[this.id]);
			graph.selectedIndex = foundIndex;
		}

		return x;
	}

	zoom(type) {
		this.showNumber += type == 'in' ? -1 : 1;
		if (this.showNumber < 1) {
			this.showNumber = 1;
		}
		else if (this.showNumber > this.list.length) {
			this.showNumber = this.list.length;
		}
		this.position = 0;
		this.calculateXLabelRange();
	}

	setColors() {
		let colors = ['blue', 'green', 'red', 'yellow', 'purple'];
		let colorIndex = 0;
		this.filteredLineObjects.map(el => {
			el.type = colors[colorIndex];
			colorIndex++;
			if (colorIndex > 4) {
				colorIndex = 0;
			}
		});
	}

	setAccumulative() {
		if (!this.accumulative) return;
		for (let val of this.lineObjects) {
			let acc = 0;
			val['valid_property'] = `${val.property}_acc`;
			for (const item of val[val.items]) {
				item[`${val.property}_acc`] = acc + Number(item[val.property]);
				acc += Number(item[val.property]);
			}
			val.total_accumulative = acc;
		}
	}

	setValidValue() {
		if (this.accumulative) return;
		for (let val of this.lineObjects) {
			val['valid_property'] = val.property;
		}
	}

	showDots(graph, item) {
		if (!graph || !graph[graph.items]) return false;
		let data = graph[graph.items].find(itm => itm[this.id] == item[this.id]);
		if (!data || !data[graph.valid_property]) return false;
		return true;
	}

	getAverageHeight(graph) {
		return this.startY - (((this.viewBoxheigth - 30) * graph[this.averageValue]) / this.max);
	}

	checkShow(graph, item) {
		if (!graph.dateToStop) return true;
		if (graph.dateToStop < item[this.xlabelValue]) return false;
		return true;
	}

	constructor(
		private _dP: DatePipe,
		private _cD: ChangeDetectorRef,
		private _fS: FilterService,
		public _gS: GlobalService) { }

	ngOnInit() {

	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.list || changes.showNumber || changes.lineObjects) {
			this.setAccumulative();
			this.setValidValue();
			this.setMax();
			if (this.showNumber > this.list.length) {
				this.showNumber = this.list.length;
			}
		}

		if ((changes.height || changes.showLegend) && this.divToMeasureElement) {
			// console.log(changes.height);
			this.setViewBoxSizes();
		}

		if (changes.textToSearch || changes.lineObjects) {
			this.positionGraph = 0;
			this.filteredLineObjects = this._fS.searchByMultipleValuesExtended(this.lineObjects, this.searchOptions, this.textToSearch);

			if (this.hoverElements) {
				this.setColors();
			}
		}
	}

	ngAfterViewInit() {
		this.setViewBoxSizes();
	}

}
